import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        color: theme.palette.text.primary,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 0,
      }}
    >
      <Box>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 700,
            fontSize: "6rem",
            color: theme.palette.primary.main,
          }}
        >
          404
        </Typography>

        <Typography variant="h5" sx={{ mb: 2 }}>
          {t("notFound.title", "Oops! Page not found.")}
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          {t(
            "notFound.subtitle",
            "The page you're looking for doesn’t exist or has been moved."
          )}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/")}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 2,
          }}
        >
          {t("notFound.button", "Back to Home")}
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
